import lottie from 'lottie-web';
const tools = require('../tools');
const logoAnim = {
    animationSpeed: 1.5,
    anim_builtUp:null,
    anim_stadt: null,
    anim_geschichte: null,
    anim_basel: null,
    jsonPath: '/.resources/stadtgeschichte-module/webresources/animatedLogo/',
    fallBackDisplay: false,

    /*DECLARE CONTAINER VARIABLES*/
    init() {
        logoAnim.fallBackDisplay = tools.detectIE() || tools.detectSafari() || window.innerWidth < 1200 || document.body.classList.contains('touch-user') || document.body.classList.contains('placeholder');
        if( tools.isEditMode()) {
            document.body.classList.add('fllbck-logo')
        } else {
            document.body.classList.add('anim-logo');
            logoAnim.initLottieAnim();
        }
    },

    initLottieAnim() {
        let Container_builtUp = document.getElementById('builtUp');
        let Container_stadt = document.getElementById('anim-stadt');
        let Container_geschichte = document.getElementById('anim-geschichte');
        let Container_basel = document.getElementById('anim-basel');

        /*DECLARE ANIMATION PARAMETERS*/

        let params_builtUp = {
            container: Container_builtUp,
            renderer: 'svg',
            loop: false,
            autoplay: false,
            path: logoAnim.jsonPath + 'builtUp.json'
        };

        let params_stadt = {
            container: Container_stadt,
            renderer: 'svg',
            loop: false,
            autoplay: false,
            path: logoAnim.jsonPath + 'stadt.json'
        };

        let params_geschichte = {
            container: Container_geschichte,
            renderer: 'svg',
            loop: false,
            autoplay: false,
            path: logoAnim.jsonPath + 'geschichte.json'
        };

        let params_basel = {
            container: Container_basel,
            renderer: 'svg',
            loop: false,
            autoplay: false,
            path: logoAnim.jsonPath + 'basel.json'
        };

        /*LOAD ALL ANIMATIONS WITH PARAMETERS*/
        logoAnim.anim_builtUp = lottie.loadAnimation(params_builtUp);
        logoAnim.anim_stadt = lottie.loadAnimation(params_stadt);
        logoAnim.anim_geschichte = lottie.loadAnimation(params_geschichte);
        logoAnim.anim_basel = lottie.loadAnimation(params_basel);


        //check active
        logoAnim.anim_builtUp.addEventListener("data_ready", function () {
            logoAnim.anim_builtUp.play();
            logoAnim.anim_builtUp.setSpeed(logoAnim.animationSpeed);
        });

        logoAnim.anim_builtUp.addEventListener("complete", function () {
            if(logoAnim.fallBackDisplay) {
                document.body.classList.remove('anim-logo');
                document.body.classList.add('fllbck-logo')
                logoAnim.fallbackHoverEffect();
            } else {
                if(Container_basel.classList.contains('active')) {
                    logoAnim.anim_basel.setSpeed(3);
                    logoAnim.anim_basel.setDirection(1);
                    logoAnim.anim_basel.play();
                }
                if(Container_geschichte.classList.contains('active')) {
                    logoAnim.anim_geschichte.setSpeed(3);
                    logoAnim.anim_geschichte.setDirection(1);
                    logoAnim.anim_geschichte.play();
                }

                if(Container_stadt.classList.contains('active')) {
                    logoAnim.anim_stadt.setSpeed(3);
                    logoAnim.anim_stadt.setDirection(1);
                    logoAnim.anim_stadt.play();
                }

                Container_stadt.style.opacity = "1";
                Container_geschichte.style.opacity = "1";
                Container_basel.style.opacity = "1";
                logoAnim.addLinkToID('navlink_stadt', Container_stadt.getAttribute('data-link'));
                logoAnim.addLinkToID('navlink_geschichte', Container_geschichte.getAttribute('data-link'));
                logoAnim.addLinkToID('navlink_basel', Container_basel.getAttribute('data-link'));
            }
            logoAnim.anim_builtUp.destroy();
        });

        Container_stadt.addEventListener("mouseover", function () {
            if(!Container_stadt.classList.contains('active')) {
                logoAnim.anim_stadt.setSpeed(logoAnim.animationSpeed);
                logoAnim.anim_stadt.setDirection(1);
                logoAnim.anim_stadt.play();
            }
        });

        Container_stadt.addEventListener("mouseout", function myRewind() {
            if(!Container_stadt.classList.contains('active')) {
                logoAnim.anim_stadt.setSpeed(logoAnim.animationSpeed);
                logoAnim.anim_stadt.setDirection(-1);
                logoAnim.anim_stadt.play();
            }
        });

        Container_geschichte.addEventListener("mouseover", function myPlay() {
            if(!Container_geschichte.classList.contains('active')) {
                logoAnim.anim_geschichte.setSpeed(logoAnim.animationSpeed);
                logoAnim.anim_geschichte.setDirection(1);
                logoAnim.anim_geschichte.play();
            }
        });

        Container_geschichte.addEventListener("mouseout", function myRewind() {
            if(!Container_geschichte.classList.contains('active')) {
                logoAnim.anim_geschichte.setSpeed(logoAnim.animationSpeed);
                logoAnim.anim_geschichte.setDirection(-1);
                logoAnim.anim_geschichte.play();
            }
        });

        Container_basel.addEventListener("mouseover", function myPlay() {
            if(!Container_basel.classList.contains('active')) {
                logoAnim.anim_basel.setSpeed(logoAnim.animationSpeed);
                logoAnim.anim_basel.setDirection(1);
                logoAnim.anim_basel.play();
            }
        });

        Container_basel.addEventListener("mouseout", function myRewind() {
            if(!Container_basel.classList.contains('active')) {
                logoAnim.anim_basel.setSpeed(logoAnim.animationSpeed);
                logoAnim.anim_basel.setDirection(-1);
                logoAnim.anim_basel.play();
            }
        });
    },

    addLinkToID(mylinkID, mylinkURL) {
        let dummyElement = document.createElement("div");
        dummyElement.innerHTML = '<a xlink:href="' + mylinkURL + '" style="cursor: pointer"></a>';

        let htmlAnchorElement = dummyElement.querySelector("a");

        let SVGelem = document.getElementById(mylinkID);

        htmlAnchorElement.innerHTML = SVGelem.innerHTML;

        SVGelem.innerHTML = dummyElement.innerHTML;
    },

    fallbackHoverEffect() {
        let links = document.querySelectorAll('#logo .links .logo-links');
        if(links.length > 0) {
            tools.each(links, link => {
                if(!link.classList.contains('active')) {
                    let key = link.getAttribute('data-keyword');
                    let svgElt = document.querySelectorAll('#logo .logo-outer-wrapper .' + key);
                    link.addEventListener('mouseenter', evt => {
                        tools.each(svgElt, elt => {
                            elt.classList.add('hover');
                        })
                    });

                    link.addEventListener('mouseleave', evt => {
                        tools.each(svgElt, elt => {
                            elt.classList.remove('hover');
                        })
                    });
                }
            })
        }
    }


};
export default logoAnim;

